import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-node-entry-default',
  templateUrl: './node-entry-default.component.html',
  styleUrls: ['./node-entry-default.component.scss']
})
export class NodeEntryDefaultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
